const config = __SERVER__ ? require('../server/run/config') : window.__config;

module.exports = config;
